import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/PaymentResultPage.css';

const PaymentResultPage = ({ status }) => {
  const isSuccess = status === 'success';

  return (
    <main className="payment-result-page">
      <section className="payment-result-card">
        <p className="payment-result-eyebrow">
          {isSuccess ? 'Payment complete' : 'Payment not completed'}
        </p>

        <h1>
          {isSuccess
            ? 'Your booking payment was successful'
            : 'Your booking is still awaiting payment'}
        </h1>

        <p>
          {isSuccess
            ? 'Stripe has accepted the payment. ViewFinders will update the booking from Stripe directly, so you do not need to keep this page open.'
            : 'No payment was completed. The booking remains pending and you can return to the conversation to try again.'}
        </p>

        <div className="payment-result-actions">
          <Link className="payment-result-primary" to="/">
            Return to ViewFinders
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PaymentResultPage;
